// React
import React from 'react';
// External libraries
import { Image, Navbar, Nav } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
// Internal
import config from 'config/config';
import getActivePath from 'utils/getActivePath';
import { isOwner } from 'services/users';
import BrandService from 'services/brand';
import VetService from 'services/vet';

// Styles
import './styles.scss';

class NavbarPrimary extends React.Component {
    constructor(props) {
        super(props);
        this.location = props.location;
        this.hideNav = props.hideNav === true ? 'hide' : ' ';
        this.state = {
            imgSrc: '',
            vetName: '',
        };
        this.getVetDetails();
    }

    /**
     * Gets the brand logo to display in the app
     */
    getBrandImage() {
        BrandService.getBrand()
            .then((response) => {
                this.setState({ imgSrc: response.data.brand_logo_link });
            }).catch((err) => {
                console.error(err);
            });
    }

    /**
     * Get Vet Detail to display the price book
     */
     getVetDetails() {
        VetService.getVetDetails()
            .then((response) => {
                this.setState({ vetName: response.data.name });
                this.setState({ imgSrc: response.data.cstm.brand.brand_logo_link });
                localStorage.setItem('vetName', response.data.name);
                localStorage.setItem('vet', JSON.stringify(response.data))
            }).catch((err) => {
                console.error(err);
            });
    }

    render() {
        return (
            <Navbar className="navbar-primary">
                <Navbar.Brand>
                    <Image
                        alt={config.webTitle}
                        src={this.state.imgSrc}
                        height="30"
                        className="d-inline-block align-top"
                    />
                </Navbar.Brand>
                <Navbar.Text className="navbar-text">
                    {this.state.vetName}
                </Navbar.Text>
                <Nav className={`nav-right-aligned ${this.hideNav}`}>
                    <Nav.Link
                        href="/dashboard"
                        className={getActivePath(this.location, '/dashboard') ? 'active' : null}
                    >
                        Dashboard
                    </Nav.Link>
                    <Nav.Link
                        href="/new-booking"
                        className={getActivePath(this.location, '/new-booking') ? 'active' : null}
                    >
                        New Booking/Order
                    </Nav.Link>
                    <Nav.Link
                        href="/bookings"
                        className={getActivePath(this.location, '/bookings') ? 'active' : null}
                    >
                        View Bookings/Orders
                    </Nav.Link>

                    {/* {
                        isOwner()
                            ? (
                                <Nav.Link
                                    href="/accounts"
                                    className={getActivePath(this.location, '/accounts') ? 'active' : null}
                                >
                                    Accounts
                                </Nav.Link>
                            ) : null
                    } */}
                </Nav>
            </Navbar>
        );
    }
}

export default withRouter(NavbarPrimary);
